
import { defineComponent } from "vue";
import PageHeading from "@/components/other/PageHeading/PageHeading.vue";

export default defineComponent({
  name: "StudentPageHeading",
  components: { PageHeading },
});
